import { render, staticRenderFns } from "./BorderModal.vue?vue&type=template&id=b82ba4b2&"
import script from "./BorderModal.vue?vue&type=script&lang=js&"
export * from "./BorderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports